import React from 'react';
import '../../App.css'; 

const About = () => {
  return (
    <div>
      {/* --- PART 1: FULL SCREEN HERO BANNER --- */}
      <div className="hero-banner">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <br /><br />
          <h1>About Divine Depot</h1>
          {/* Divider Image (White via CSS) */}
          <img src="/assets/images/image8.png" alt="divider" className="hero-divider" />
          
          <p className="hero-text">
            At Divine Depot, spirituality isn't just a business – it's a family tradition passed down through generations. What started as a humble endeavour rooted in our deep reverence for the sacred has blossomed into a cherished sanctuary for seekers of spiritual wisdom and enlightenment.
            We believe that every ritual, every prayer, and every moment of silence deserves the purest accompaniments.
          </p>
        </div>
      </div>

      {/* --- PART 2: THE REST OF THE CARDS --- */}
      <div className="about-page-main">
        
        {/* --- Section 2: Our Vision --- */}
        <div className="vision-row">
          <div 
            className="vision-image-box" 
            style={{ backgroundImage: 'url("/assets/images/Group 185.png")' }}
          ></div>
          
          <div className="vision-text-card">
            {/* Vines */}
            <img src="/assets/images/Clip path group (1).png" alt="decor" className="card-vine vine-top-left" />
            <img src="/assets/images/Clip path group.png" alt="decor" className="card-vine vine-bottom-right" />
            
            <h3>Our Vision</h3>
            <img src="/assets/images/image8.png" alt="divider" className="card-divider" />
            <p>
              At Divine Depot, our values are deeply intertwined with our family heritage. Purity, authenticity, and tradition guide everything we do, ensuring that each product we offer carries the essence of sacredness and reverence. Our commitment to integrity and respect is reflected in every interaction with our customers and partners.
            </p>
          </div>
        </div>

        {/* --- Section 3: Core Values --- */}
        <div className="vision-row reverse">
          <div 
            className="vision-image-box" 
            style={{ backgroundImage: 'url("/assets/images/Group 184.png")' }}
          ></div>
          
          <div className="vision-text-card">
            {/* Vines */}
            <img src="/assets/images/Clip path group (1).png" alt="decor" className="card-vine vine-top-left" />
            <img src="/assets/images/Clip path group.png" alt="decor" className="card-vine vine-bottom-right" />

            <h3>Core Values</h3>
            <img src="/assets/images/image8.png" alt="divider" className="card-divider" />
            <p>
              As a family-owned business, every member of the Divine Depot team plays a vital role in our mission. From sourcing the finest ingredients to crafting each product with care and intention, we pour our hearts and souls into every aspect of our business. Meet the faces behind Divine Depot and discover the passion and dedication that drive us forward.
            </p>
          </div>
        </div>

        {/* --- Section 4: Meet Our Family --- */}
        <div className="vision-row">
          <div 
            className="vision-image-box" 
            style={{ backgroundImage: 'url("/assets/images/Mask group.png")' }}
          ></div>
          
          <div className="vision-text-card">
            {/* Vines */}
            <img src="/assets/images/Clip path group (1).png" alt="decor" className="card-vine vine-top-left" />
            <img src="/assets/images/Clip path group.png" alt="decor" className="card-vine vine-bottom-right" />

            <h3>Meet Our Family</h3>
            <img src="/assets/images/image8.png" alt="divider" className="card-divider" />
            <p>
              As a family-owned business, every member of the Divine Depot team plays a vital role in our mission. From sourcing the finest ingredients to crafting each product with care and intention, we pour our hearts and souls into every aspect of our business. Meet the faces behind Divine Depot and discover the passion and dedication that drive us forward.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;